const monitorTypes = {
    BOOK: 'BOOK', // Book
    // MINI_TICKER: 'MINI_TICKER', // Mini-Ticker
    USER_DATA: 'USER_DATA', // User Data

    CANDLES: 'CANDLES',
    TICKER: 'TICKER',
    FUNDING_RATE: 'FUNDING_RATE',
    MARKET_REGIME: 'MARKET_REGIME',
    MARKET_SCANNER: 'MARKET_SCANNER'
}

const monitorTypesSelect = {
    BOOK: 'Book Ticker',
    CANDLES: 'Candles',
    FUNDING_RATE: 'Funding Rate',
    MARKET_REGIME: 'Regime de Mercado',
    MARKET_SCANNER: 'Scanner de Mercado'
    // ,TICKER: 'Ticker'
}

function getMonitorTypeLabel(type) {
    return monitorTypesSelect[type] || type;
}

module.exports = {
    monitorTypes,
    monitorTypesSelect,
    getMonitorTypeLabel
}